import Typography from "@/elements/Typography";
import Box from "@/elements/Box";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useAuth } from "@/context/useAuth";
import ModelliFiltroTableCard from "@/components/ConfigurazionePage/ModelliFiltroTableCard";
import {
  useGetDescrizioniBonifica,
  useGetDescrizioniManutenzione,
  useGetModelliFiltro,
  useGetModelliOlio,
  useGetModelliGateway,
  useGetNodoIcone,
} from "@/api";
import Loading from "@/components/Loading";
import LoadingError from "@/components/LoadingError";
import ModelliOlioTableCard from "@/components/ConfigurazionePage/ModelliOlioTableCard";
import ModelliGatewayTableCard from "@/components/ConfigurazionePage/ModelliGatewayTableCard";
import DescrizioniBonificaTableCard from "@/components/ConfigurazionePage/DescrizioniBonificaTableCard";
import NodoIconeTableCard from "@/components/ConfigurazionePage/NodoIconeTableCard";
import { useTranslation } from "react-i18next";
import DescrizioniManutenzioneTableCard from "./DescrizioniManutenzioneTableCard";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";

export default function ConfigurazionePage() {
  const { hasPermission } = useAuth();
  const { t } = useTranslation();

  const {
    isLoading: isLoadingModelliFiltro,
    data: modelliFiltro,
    error: errorModelliFiltro,
  } = useGetModelliFiltro();
  const {
    isLoading: isLoadingModelliOlio,
    data: modelliOlio,
    error: errorModelliOlio,
  } = useGetModelliOlio();
  const {
    isLoading: isLoadingModelliGateway,
    data: modelliGateway,
    error: errorModelliGateway,
  } = useGetModelliGateway();
  const {
    isLoading: isLoadingDescrizioniBonifica,
    data: descrizioniBonifica,
    error: errorDescrizioniBonifica,
  } = useGetDescrizioniBonifica();
  const {
    isLoading: isLoadingDescrizioniManutenzione,
    data: descrizioniManutenzione,
    error: errorDescrizioniManutenzione,
  } = useGetDescrizioniManutenzione();

  const canManageNodoIcone = hasPermission("NodoIconeChange");
  const {
    isLoading: isLoadingNodoIcone,
    data: nodoIcone,
    error: errorNodoIcone,
  } = useGetNodoIcone({
    query: {
      enabled: canManageNodoIcone,
    },
  });

  const isLoading =
    isLoadingModelliFiltro ||
    isLoadingModelliOlio ||
    isLoadingModelliGateway ||
    isLoadingDescrizioniBonifica ||
    isLoadingDescrizioniManutenzione ||
    (canManageNodoIcone && isLoadingNodoIcone);
  if (isLoading) {
    return <Loading />;
  }

  const error =
    errorModelliFiltro ||
    errorModelliOlio ||
    errorModelliGateway ||
    errorDescrizioniBonifica ||
    errorDescrizioniManutenzione ||
    (canManageNodoIcone ? errorNodoIcone : null);
  if (error) {
    return <LoadingError error={error} />;
  }

  return (
    <Box p={2}>
      <Box
        display="flex"
        flexWrap="wrap"
        alignItems="center"
        justifyContent="space-between"
        mb={2}
      >
        <Typography variant="h4" mr={2}>
          Configurazione
        </Typography>
      </Box>

      <Box display="flex" flexDirection="column" gap={2}>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">
              {t("modelliFiltroTableCard.titolo")}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <ModelliFiltroTableCard
              modelliFiltro={modelliFiltro?.data ?? []}
              canEdit={hasPermission("ModelliFiltroChange")}
            />
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">
              {t("modelliOlioTableCard.titolo")}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <ModelliOlioTableCard
              modelliOlio={modelliOlio?.data ?? []}
              canEdit={hasPermission("ModelliOlioChange")}
            />
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">
              {t("modelliGatewayTableCard.titolo")}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <ModelliGatewayTableCard
              modelliGateway={modelliGateway?.data ?? []}
              canEdit={hasPermission("ModelliGatewayChange")}
            />
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">
              {t("descrizioniBonificaTableCard.titolo")}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <DescrizioniBonificaTableCard
              descrizioniBonifiche={descrizioniBonifica?.data || []}
              canEdit={hasPermission("DescrizioniBonificaChange")}
            />
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">
              {t("descrizioniManutenzioneTableCard.titolo")}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <DescrizioniManutenzioneTableCard
              descrizioniManutenzioni={descrizioniManutenzione?.data || []}
              canEdit={hasPermission("DescrizioniManutenzioneChange")}
            />
          </AccordionDetails>
        </Accordion>

        {canManageNodoIcone && (
          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="h6">
                {t("nodoIconeTableCard.titolo")}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <NodoIconeTableCard
                nodoIcone={nodoIcone?.data ?? []}
                canEdit={canManageNodoIcone}
              />
            </AccordionDetails>
          </Accordion>
        )}
      </Box>
    </Box>
  );
}
